import { useAtomValue } from 'jotai';
import { featureFlagsAtom } from 'lib-knowledge-utils/stores/featureFlags';

/**
 * Whether to show the AI-provenance UI — the `AI-assisted` badge and the source
 * conversations chip.
 *
 * Gated on the same flag as the multi-conversation draft flow, which is what
 * populates the provenance in the first place: with the flag off, no article
 * gains it, so the UI would only ever mark articles drafted while it was on.
 */
export function useShowAiProvenance(): boolean {
  const { featureFlags } = useAtomValue(featureFlagsAtom);

  return featureFlags.smartArticleCreateMultiConversation;
}
